import baseConfig from "./config.json";
import { getEnvironment } from "./util/ContextHelper";

interface Configuration
{
    baseURL: string;
    mediaURL: string;
    redirectURL: string;
    apiKey: string;
}

const createConfiguration = (): Configuration =>
{
    const environment = getEnvironment();
    const environmentConfig = require(`./config.${environment}.json`) as Configuration;
    return { ...baseConfig, ...environmentConfig } as Configuration;
};

const configuration = createConfiguration();

export default configuration;
